import React from "react";
import {toPublicUrl} from "src/modules/util/UrlUtil";

export class LoaderComponentImage extends React.Component {
    render() {
        return <img color={"primary"} src={toPublicUrl("/images/icons/animated/loader.svg")}/>;
    }
}